export const DOWNLOAD_TO_EXCEL_REQUEST = 'DOWNLOAD_TO_EXCEL_REQUEST';
export const DOWNLOAD_TO_EXCEL_SUCCESS = 'DOWNLOAD_TO_EXCEL_SUCCESS';
export const DOWNLOAD_TO_EXCEL_FAILURE = 'DOWNLOAD_TO_EXCEL_FAILURE';

export const DOWNLOAD_TO_EXCEL = 'DOWNLOAD_TO_EXCEL';

export const DOWNLOAD_TO_GDRIVE_REQUEST = 'DOWNLOAD_TO_GDRIVE_REQUEST';
export const DOWNLOAD_TO_GDRIVE_SUCCESS = 'DOWNLOAD_TO_GDRIVE_SUCCESS';
export const DOWNLOAD_TO_GDRIVE_FAILURE = 'DOWNLOAD_TO_GDRIVE_FAILURE';

export const DOWNLOAD_TO_GDRIVE = 'DOWNLOAD_TO_GDRIVE';
